import avatar from './avatar';
import badge from './badge';
import breakpoints from './breakpoints';
import button from './button';
import checkbox from './checkbox';
import colors from './colors';
import counterBadge from './counterBadge';
import link from './link';
import { radii, shadows } from './miscellaneous';
import radio from './radio';
import space from './space';
import textFieldInput from './textFieldInput';
import toggleTheme from './toggle';
import typography from './typography';
var theme = {
  typography: typography,
  colors: colors,
  space: space,
  radii: radii,
  shadows: shadows,
  button: button,
  link: link,
  avatar: avatar,
  badge: badge,
  counterBadge: counterBadge,
  checkbox: checkbox,
  radio: radio,
  textFieldInput: textFieldInput,
  toggle: toggleTheme,
  breakpoints: breakpoints
};
export default theme;